import React, { Component } from 'react'
import HomeHeader from '../components/HomeHeader'
import HomeContent from '../components/HomeContent'
import HomeContact from '../components/HomeContact'
import HomeFooter from '../components/HomeFooter'

export default class HomeJK extends Component {
    render() {
        var detail = "JK物语是一款设计类实用工具APP，你可以自由搭配形制、颜色、暗纹、印花来设计独一无二的JK服饰，也可以浏览其他用户分享的设计汲取灵感";
        return (
            <div style={{padding:'40px'}}>
                <HomeHeader icon='icon_jk.png' title='JK物语' detail={detail}/>
                <HomeContent title='JKS穿搭设计参考' subtitle='DIY你的专属JKS' ios='ios_qrcode.png' android='android_qrcode.png' snapshot='snapshot_jk.jpeg'/>
                <HomeContact agreement='http://jkfile.iyztp.com/2022/01/20/5e68e980401a0be280664ae5589b1e07.html' privacy='http://jkfile.iyztp.com/2022/01/20/a7c15de940e90dbe806239bc96826708.html'/>
                <HomeFooter/>
            </div>
        )
    }
}